'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroPanel = require('./NitroPanel');

var _NitroPanel2 = _interopRequireDefault(_NitroPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroPanel2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-panel/index.js
// module id = 21
// module chunks = 4